// TodayTab.tsx
import { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import RecentTask from "./RecentTasks";
import TodaysTask from "./TodaysTask";
import { activitySubTabsSx } from "./activityTabsSx";

const TodayTab = () => {
  const [tabIndex, setTabIndex] = useState(() => {
    const savedTabIndex = sessionStorage.getItem("todayTabIndex");
    return savedTabIndex ? Number(savedTabIndex) : 0;
  });

  useEffect(() => {
    sessionStorage.setItem("todayTabIndex", tabIndex.toString());
    // Reset current page when switching tabs
    sessionStorage.setItem("todaysTaskCurrentPage", "1");
  }, [tabIndex]);

  const taskSource = tabIndex === 0 ? "ticket" : "email";

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={(_, val) => setTabIndex(val)}
        sx={activitySubTabsSx}
      >
        <Tab label="Tickets" />
        <Tab label="Emails" />
      </Tabs>

      <div className="pt-3 px-3 pb-0">
        <TodaysTask task_source={taskSource} />
      </div>
    </>
  );
};

export default TodayTab;